/*
// Sai krishna 11/17/2022 2700271704 Action dropdown -- Dynamically rendered fields -- Change dispo section.
// Sai krishna 11/17/2022 2700271704 Action dropdown -- Validation bug fixes.
Sai Maheshwar 11/20/2022 2700271704 fixed add action bugs and added validations
akhila 12/21/2022 2700271704 changed labels
kavyareddy 12/26/2022 2700271704 Fixed label issues
Raghu 02/22/2023 2700271704 added new class to input fields
Raghu 02/28/2023 2700271704 added new class to input fields
suresh peddavoora 03/06/2023 2700271704 New UI changes for textfields
Rohini 03/27/2023 2700271704 fixed the helper text issue
suresh peddavoora 04/06/2023 2700271704 fields alignment fixes
Prakash 13/04/2023 2700271704 remove margin top
Sohel 06/13/2023 2701334326 Added Date Stamp popup
Prakash 14/04/2023 2700271704 fixed  alignments issues
Dipip-pds 10/20/2023 2700271704 fixed prepopulate issue of wait Date
Sohel 11/30/2023 2700271704 data calculation field disable css modified and radio button on data calculation popup open
*/

import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  makeStyles,
} from '@material-ui/core';
import {Clear, Search} from '@material-ui/icons';
import {KeyboardDatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import React, {useEffect, useContext} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {CLOSURE_CODE, DISPOSITION_CODE} from '../../../../../constants/Lookup';
import {
  fetchDispositionCodes,
  handleSearchRuleGroupFieldData,
} from '../../../../../redux/reducers/EventTactics/EventTactics';
import DateFnsUtils from '@date-io/date-fns';
import {NumberFormatterPostiveNegavtive} from '../../../../../components/UserDefinedForm/AppTextInputComponents';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';

const ChangeDisposition = (props) => {
  const useStyles = makeStyles((theme) => ({
    communicationRadioButtons: {
      '& .MuiFormControlLabel-root': {
        marginBottom: '20px',
      },
    },
    communicationCheckBoxes: {
      'padding': '5px 10px',
      '& .MuiFormControl-marginDense': {
        margin: '0 !important',
      },
      '& .MuiFormControlLabel-label': {
        fontSize: '14px !important',
        fontFamily: 'articulat-cf, sans-serif !important',
      },
    },
    communicationRadioButtonsLabel: {
      'padding': '5px 10px',
      '& .MuiFormLabel-root': {
        fontWeight: '600',
        marginBottom: '0',
      },
      '& .MuiFormControlLabel-label': {
        fontSize: '14px !important',
        fontFamily: 'articulat-cf, sans-serif !important',
      },
    },
    groupWrapper: {
      '& .MuiFormGroup-root': {
        flexWrap: 'nowrap !important',
      },
      '& .MuiFormControlLabel-root': {
        marginRight: '3rem !important',
        [theme.breakpoints.down('md')]: {
          marginRight: '1rem !important',
        },
      },
    },
  }));

  const {dispositionDropDown} = useSelector(
    ({addEventTactic}) => addEventTactic,
  );
  const styles = useStyles();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchDispositionCodes());
  }, []);
  const getOptions = (typeCode) => {
    let label = [];

    label =
      dispositionDropDown && dispositionDropDown[typeCode] ? dispositionDropDown[typeCode] : [];

    return label;
  };
  const label = ['Wait Date', 'Fixed Wait Date', 'Data Calculation'];

  const applyToOptions = [{key: 'R', value: 'R - Route'}];
  const overRideOptions = [
    {key: 'Y', value: 'Yes'},
    {key: 'N', value: 'No'},
  ];
  const {
    setShowSearch,
    values,
    setFieldValue,
    touched,
    errors,
    handleChange,
    handleBlur,
  } = props;
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  return (
    <>
      <Grid container spacing={4} className="new-standard-textfields m-0">
        <Grid item sm={4} className={`form-group  ${classes.selectField} dropdown-icon`}>
          <FormControl margin="dense" variant="outlined" fullWidth>
            <InputLabel id="demo-simple-select-label" required>
              Apply To
            </InputLabel>
            <Select
              id="demo-simple-select"
              labelId="demo-simple-select-label"
              fullWidth
              name="applyTo"
              className={`select-gender ${classes.labelName}`}
              required
              value={values?.applyTo || 'none'}
              //   value={a.subtotal || "none"}
              onChange={handleChange}
              onBlur={handleBlur}
              touched={touched?.applyTo}
              error={Boolean(touched?.applyTo && errors?.applyTo)}
              // helperText={touched?.applyTo && errors.applyTo && errors.applyTo}
              label={'Select Apply To'}
            >
              <MenuItem value="none" key="none" disabled selected>
                <span className="defaultSelected"> Select Apply To </span>
              </MenuItem>
              {applyToOptions.map((option) => {
                return (
                  <MenuItem value={option.key} key={option.key}>
                    {option.value}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
          <FormHelperText>{touched?.applyTo && errors && errors.applyTo}</FormHelperText>
        </Grid>
        <Grid item sm={4} className="form-group ">
          <FormControl margin="dense" variant="outlined" fullWidth>
            <GuiAutoComplete
              classes={{
                option: classes.option,
              }}
              name={'disposition'}
              id={'disposition'}
              size="small"
              value={values?.disposition}
              onChange={(e, value) => {
                // handleChange(e)
                setFieldValue('disposition', value);
              }}
              // helperText={touched?.disposition && errors.disposition && errors.disposition}
              options={getOptions(DISPOSITION_CODE)}
              getOptionLabel={(option) => {
                return option && option.value
                  ? option.valueCode === null
                    ? option.value
                    : option.valueCode + ' - ' + option.value
                  : '';
              }}
              renderInput={(params) => (
                <div className="select-field">
                  <GuiTextField
                    {...params}
                    variant="outlined"
                    className={`${classes.labelName}`}
                    margin="dense"
                    // touched={touched.disposition}
                    onBlur={handleBlur}
                    error={Boolean(touched?.disposition && errors?.disposition)}
                    // InputLabelProps={{ shrink: true }}
                    label={'Status'}
                    placeholder={`Select Status`}
                    // className={` ${classes.labelName} ${classes.selectLabel}`}
                  />
                </div>
              )}
            />
          </FormControl>
          <FormHelperText>{touched?.disposition && errors && errors.disposition}</FormHelperText>
        </Grid>
        <Grid item xs={4} className={`form-group ${classes.selectField} dropdown-icon`}>
          <FormControl margin="dense" variant="outlined" fullWidth>
            <InputLabel id="demo-simple-select-label" required>
              Override
            </InputLabel>
            <Select
              id="demo-simple-select"
              labelId="demo-simple-select-label"
              fullWidth
              name="overRide"
              className={`select-gender ${classes.labelName}`}
              required
              value={values?.overRide || 'none'}
              //   value={a.subtotal || "none"}
              defaultValue="none"
              onChange={handleChange}
              onBlur={handleBlur}
              touched={touched.overRide}
              error={Boolean(touched?.overRide && errors?.overRide)}
              // helperText={touched?.overRide && errors.overRide && errors.overRide}
              label="Select Override"
            >
              <MenuItem value="none" key="none" disabled selected>
                <span className="defaultSelected"> Select Override </span>
              </MenuItem>
              {overRideOptions.map((option) => {
                return (
                  <MenuItem value={option.key} key={option.key}>
                    {option.value}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
          <FormHelperText>{touched?.overRide && errors && errors.overRide}</FormHelperText>
        </Grid>
      </Grid>

      <Grid container spacing={4} className="new-standard-textfields m-0">
        <Grid item xs={12} sm={12}>
          <div className={`${styles.groupWrapper} d-flex`}>
            <FormControl component="fieldset">
              <RadioGroup
                row
                name="updateDateBy"
                aria-label="gender"
                value={values?.updateDateBy}
                defaultValue={'Wait Date'}
                onChange={(e) => {
                  setFieldValue('updateDateBy', e.target.value);
                  setFieldValue('daysToWait', '');
                  setFieldValue('waitDate', null);
                  setFieldValue('ruleGroup', '');
                  if (e.target.value === 'Data Calculation') {
                    dispatch(
                      handleSearchRuleGroupFieldData({
                        status: true,
                        fieldName: 'ruleGroup',
                        setFieldValue: setFieldValue,
                        setShowSearch: setShowSearch,
                        returnType: 'Date',
                      }),
                    );
                    setShowSearch(true);
                  }
                }}
              >
                {label.map((item, i) => (
                  <FormControlLabel
                    key={i}
                    value={item}
                    control={<Radio name={item} />}
                    label={item}
                  />
                ))}
              </RadioGroup>
            </FormControl>

            {values?.updateDateBy === 'Wait Date' ? (
              <Grid item sm={4} className="form-group">
                <TextField
                  margin="dense"
                  variant="outlined"
                  className={`${classes.labelName}`}
                  placeholder={`Enter Wait Date`}
                  label={'Wait Date'}
                  // InputLabelProps={{
                  //   shrink: true,
                  // }}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">Today +</InputAdornment>,
                    inputComponent: NumberFormatterPostiveNegavtive,
                  }}
                  name={'daysToWait'}
                  value={values?.daysToWait}
                  onChange={(e) => {
                    setFieldValue('daysToWait', e.target.value);
                  }}
                  fullWidth
                  onBlur={handleBlur}
                  touched={touched.daysToWait}
                  error={touched?.daysToWait && errors.daysToWait && errors.daysToWait}
                  // helperText={touched?.waitDays && errors.waitDays && errors.waitDays}
                />
                {/* <FormHelperText>
                         {errors.waitDays && errors.waitDays}
                     </FormHelperText> */}
              </Grid>
            ) : values?.updateDateBy === 'Fixed Wait Date' ? (
              <Grid item sm={4} className="form-group">
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    className={`${classes.labelName}`}
                    name={'waitDate'}
                    format="MM/dd/yyyy"
                    placeholder="MM/DD/YYYY"
                    label={'Fixed Wait Date'}
                    fullWidth
                    value={values?.waitDate || null}
                    inputVariant="outlined"
                    margin="dense"
                    onChange={(date) => {
                      setFieldValue('waitDate', date);
                      //   if (calculateWaitDays(date) <= 30) {
                      //     setFieldValue("waitDays", calculateWaitDays(date));
                      //     // setDateChange(true);
                      //     return { value: date };
                      //   }
                    }}
                    // InputLabelProps={{
                    //   shrink: true,
                    // }}
                    autoOk
                  />
                </MuiPickersUtilsProvider>
                {/* <FormHelperText>
                        {errors.waitDate && errors.waitDate}
                    </FormHelperText> */}
              </Grid>
            ) : values?.updateDateBy === 'Data Calculation' ? (
              <Grid item sm={4} className="form-group wait-date-disable-field">
                <TextField
                  margin="dense"
                  variant="outlined"
                  placeholder={`Enter Wait Date Data Calculation`}
                  label={'Wait Date Data Calculation'}
                  disabled
                  className={`label-overflow ${classes.labelName}`}
                  name={'ruleGroup'}
                  value={values?.ruleGroup?.dataCalculation ? values?.ruleGroup?.dataCalculation : values?.ruleGroup ? values?.ruleGroup : '' }
                  onChange={(e) => {
                    setFieldValue('ruleGroup', e.target.value);
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Search
                          className={` ${classes.iconSearch}`}
                          onClick={() => {
                            dispatch(
                              handleSearchRuleGroupFieldData({
                                status: true,
                                fieldName: 'ruleGroup',
                                setFieldValue: setFieldValue,
                                setShowSearch: setShowSearch,
                                returnType: 'Date',
                              }),
                            );
                            setShowSearch(true);
                          }}
                          size="sm"
                        />
                        <Clear
                          className={` ${classes.iconSearch}`}
                          onClick={(e) => setFieldValue('ruleGroup', '')}
                        />
                      </InputAdornment>
                    ),
                  }}
                  fullWidth
                  onBlur={handleBlur}
                  touched={touched.ruleGroup}
                  error={touched?.ruleGroup && errors.ruleGroup && errors.ruleGroup}
                  helperText={touched?.ruleGroup && errors.ruleGroup && errors.ruleGroup}
                />
                <FormHelperText>
                  {touched?.ruleGroup && errors.ruleGroup && errors.ruleGroup}
                </FormHelperText>
              </Grid>
            ) : null}
          </div>
          <div>
            {values?.disposition?.valueCode === '9000' ? (
              <>
                <Grid item sm={4} className="form-group">
                  <GuiAutoComplete
                    classes={{
                      option: classes.option,
                    }}
                    name={'cancelCode'}
                    id={'cancelCode'}
                    size="small"
                    value={values?.cancelCode ? values?.cancelCode : ''}
                    onChange={(e, value) => {
                      setFieldValue('cancelCode', value);
                    }}
                    //   disabled={
                    //     !(
                    //       values?.disposition?.valueCode === "9000" ||
                    //       values?.disposition?.valueCode === "9999"
                    //       )
                    //     }
                    options={getOptions(CLOSURE_CODE)}
                    getOptionLabel={(option) => {
                      return option && option.value
                        ? option.valueCode === null
                          ? option.value
                          : option.valueCode + ' - ' + option.value
                        : '';
                    }}
                    renderInput={(params) => (
                      <div className="select-field">
                        <GuiTextField
                          {...params}
                          variant="outlined"
                          margin="dense"
                          // InputLabelProps={{ shrink: true }}
                          label={'Cancel Code'}
                          placeholder={`Select Cancel Code`}
                          className={`${classes.labelName}`}
                        />
                      </div>
                    )}
                  />
                  <FormHelperText>
                    {touched?.cancelCode && errors && errors.cancelCode}
                  </FormHelperText>
                </Grid>
              </>
            ) : null}
          </div>
        </Grid>

        {/* <FormControl margin="dense" variant="outlined" fullWidth> */}

        {/* </FormControl> */}
      </Grid>
    </>
  );
};

export default ChangeDisposition;
